import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const Button = ({
  className,
  mauto,
  disabled,
  pushTo,
  to,
  mleft,
  mright,
  mtop,
  mbottom,
  isLoading,
  loadingComponent: LoadingComponent,
  outline,
  link,
  ...props
}) => {
  const classNamesProps = {
    [className]: className,
    mauto,
    disabled,
    mleft,
    mright,
    mtop,
    mbottom,
    outline,
    link,
  };

  const defaultClass = props.defaultClass ? props.defaultClass : 'forms-Button';

  if (to) {
    return (
      <button
        {...props}
        disabled={disabled}
        onClick={() => pushTo(to)}
        className={classNames(defaultClass, classNamesProps)}
      >
        {props.children}
      </button>
    );
  }

  return (
    <button
      {...props}
      disabled={disabled}
      className={classNames(defaultClass, classNamesProps)}
    >
      {!isLoading ? props.children : <LoadingComponent />}
    </button>
  );
};

Button.defaultProps = {
  mauto: false,
  className: null,
  disabled: false,
  to: null,
  mleft: false,
  mright: false,
  mtop: false,
  mbottom: false,
  isLoading: false,
  loadingComponent: null,
  outline: false,
  link: false,
  children: null
};

Button.propTypes = {
  className: PropTypes.string,
  mauto: PropTypes.bool,
  mleft: PropTypes.bool,
  mright: PropTypes.bool,
  mtop: PropTypes.bool,
  mbottom: PropTypes.bool,
  isLoading: PropTypes.bool,
  loadingComponent: PropTypes.any,
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
  link: PropTypes.bool,
  defaultClass: PropTypes.string,
  to: PropTypes.string,
  pushTo: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ])
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  pushTo: push,
}, dispatch);

export default connect(null, mapDispatchToProps)(Button);
